import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useTranslator } from '@/hooks/useTranslator';
import { INSPECTOR_UI_ATTRIBUTE } from './inspectElement';
import { TranslationKeyEditor } from './TranslationKeyEditor';

export function InspectorPanel({
  keys,
  onClose,
}: {
  keys: string[];
  onClose: () => void;
}) {
  const { getTranslation: t } = useTranslator({ page: 'translationInspector' });
  const [current, setCurrent] = useState(keys[0] ?? '');

  return (
    <Sheet open onOpenChange={open => !open && onClose()}>
      <SheetContent
        {...{ [INSPECTOR_UI_ATTRIBUTE]: '' }}
        className='flex flex-col gap-0 p-0 sm:max-w-[520px]'
      >
        <SheetHeader className='shrink-0 border-b px-6 py-4'>
          <SheetTitle className='text-base'>{t('panel.title')}</SheetTitle>
          <p className='text-xs text-muted-foreground'>
            {t('panel.description')}
          </p>
        </SheetHeader>
        {keys.length > 1 && (
          <div className='flex shrink-0 flex-col gap-2 border-b px-6 py-3'>
            <p className='text-xs text-muted-foreground'>
              {t('panel.several')}
            </p>
            <div className='flex flex-wrap gap-1.5'>
              {keys.map(id => (
                <Button
                  key={id}
                  size='sm'
                  variant={id === current ? 'default' : 'outline'}
                  className='font-mono'
                  onClick={() => setCurrent(id)}
                >
                  {id}
                </Button>
              ))}
            </div>
          </div>
        )}
        <TranslationKeyEditor key={current} id={current} onNavigate={onClose} />
      </SheetContent>
    </Sheet>
  );
}
